import React from 'react';
import Button from '@material-ui/core/Button';
import moment from 'moment';

const Footer = () => {
  const version = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BUILD_VERSION)
    ? String(process.env.REACT_APP_BUILD_VERSION).replace(/^#/, '')
    : '';
  const releasedAt = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BUILD_RELEASED_AT)
    ? process.env.REACT_APP_BUILD_RELEASED_AT
    : '';
  const buildUrl = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BUILD_URL)
    ? process.env.REACT_APP_BUILD_URL
    : 'https://github.com/Foster-Lending/rfs-lending-platform';

  const released = releasedAt ? moment(releasedAt) : null;
  const relative = released && released.isValid() ? released.fromNow() : '';
  const fullDate = released && released.isValid()
    ? released.utc().format('YYYY-MM-DD HH:mm:ss [UTC]')
    : '';
  const label = version
    ? (relative ? `Version ${version} - Released ${relative}` : `Version ${version}`)
    : '';

  return (
    <footer className="app-footer">
      <span className="d-inline-block">Regions Financial Services &copy; 2020</span>
      {label ? (
        <Button
          href={buildUrl}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          color="primary"
          title={fullDate || undefined}
        >
          {label}
        </Button>
      ) : null}
    </footer>
  );
};

export default Footer;
